// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-l_hm","advertDetailServiceList__header":"c-l_hn","advertDetailServiceList__list":"c-l_ho"};